
import { TravelArea } from './types';

export const travelAreas: TravelArea[] = [
  {
    name: 'Stellenbosch',
    postalCodes: ['7600', '7601', '7602', '7603', '7604', '7605', '7607', '7608', '7611', '7612', '7613', '7614', '7615'],
    fee: 0
  },
  {
    name: 'Firgrove',
    postalCodes: ['7110'],
    fee: 500
  },
  {
    name: 'Eerste River',
    postalCodes: ['7100'],
    fee: 500
  },
  {
    name: 'Macassar',
    postalCodes: ['7130'],
    fee: 500
  },
  {
    name: 'Strand',
    postalCodes: ['7140'],
    fee: 500
  },
  {
    name: 'Klapmuts',
    postalCodes: ['7625'],
    fee: 0
  },
  {
    name: 'Kuils River',
    postalCodes: ['7580'],
    fee: 500
  },
  {
    name: 'Blackheath',
    postalCodes: ['7581'],
    fee: 500
  },
  {
    name: 'Brackenfell',
    postalCodes: ['7560'],
    fee: 500
  },
  {
    name: 'Kraaifontein',
    postalCodes: ['7570'],
    fee: 500
  },
  {
    name: 'Durbanville',
    postalCodes: ['7550'],
    fee: 500
  },
  {
    name: 'Paarl',
    postalCodes: ['7646'],
    fee: 500
  },
  {
    name: 'Franschhoek',
    postalCodes: ['7690'],
    fee: 500
  },
  {
    name: 'Bellville',
    postalCodes: ['7530'],
    fee: 750
  },
  {
    name: 'Parow',
    postalCodes: ['7500'],
    fee: 750
  },
  {
    name: 'Goodwood',
    postalCodes: ['7460'],
    fee: 750
  },
  {
    name: 'Observatory',
    postalCodes: ['7925'],
    fee: 750
  },
  {
    name: 'Rondebosch',
    postalCodes: ['7700'],
    fee: 750
  },
  {
    name: 'Wellington',
    postalCodes: ['7654'],
    fee: 750
  },
  {
    name: 'Grabouw',
    postalCodes: ['7160'],
    fee: 750
  },
  {
    name: 'Claremont',
    postalCodes: ['7708'],
    fee: 750
  },
  {
    name: 'Mitchells Plain',
    postalCodes: ['7785'],
    fee: 750
  },
  {
    name: 'Strandfontein',
    postalCodes: ['7798'],
    fee: 750
  },
  {
    name: 'Retreat',
    postalCodes: ['7945'],
    fee: 750
  },
  {
    name: 'Cape Town (CBD)',
    postalCodes: ['8001'],
    fee: 750
  },
  {
    name: 'Wynberg',
    postalCodes: ['7800'],
    fee: 750
  },
  {
    name: 'Sea Point',
    postalCodes: ['8005'],
    fee: 750
  },
  {
    name: 'Villiersdorp',
    postalCodes: ['6848'],
    fee: 750
  },
  {
    name: 'Botrivier',
    postalCodes: ['7185'],
    fee: 750
  },
  {
    name: 'Bloubergstrand',
    postalCodes: ['7441'],
    fee: 750
  },
  {
    name: 'Worcester',
    postalCodes: ['6849'],
    fee: 1000
  },
  {
    name: 'Hermanus',
    postalCodes: ['7200'],
    fee: 1000
  },
  {
    name: 'Wolseley',
    postalCodes: ['6830'],
    fee: 1000
  },
  {
    name: 'Tulbagh',
    postalCodes: ['6820'],
    fee: 1250
  },
  {
    name: 'Stanford',
    postalCodes: ['7210'],
    fee: 1250
  },
  {
    name: 'Yzerfontein',
    postalCodes: ['7351'],
    fee: 1250
  },
  {
    name: 'Porterville',
    postalCodes: ['6810'],
    fee: 1250
  },
  {
    name: 'Piketberg',
    postalCodes: ['7320'],
    fee: 1500
  },
  {
    name: 'Saldanha',
    postalCodes: ['7395'],
    fee: 1500
  },
  {
    name: 'Langebaan',
    postalCodes: ['7357'],
    fee: 1500
  },
  {
    name: 'Gansbaai',
    postalCodes: ['7220'],
    fee: 1500
  },
  {
    name: 'Velddrif',
    postalCodes: ['7365'],
    fee: 1500
  },
  {
    name: 'Montagu',
    postalCodes: ['6720'],
    fee: 1500
  },
  {
    name: 'Suurbraak',
    postalCodes: ['6743'],
    fee: 1500
  },
  {
    name: 'Bredasdorp',
    postalCodes: ['7280'],
    fee: 1500
  },
  {
    name: 'Swellendam',
    postalCodes: ['6740'],
    fee: 1750
  },
  {
    name: 'Heidelberg',
    postalCodes: ['6665'],
    fee: 2000
  },
  {
    name: 'Riversdale',
    postalCodes: ['6670'],
    fee: 2250
  },
  {
    name: 'Ladismith',
    postalCodes: ['6655'],
    fee: 2250
  },
  {
    name: 'Witsand',
    postalCodes: ['6666'],
    fee: 2250
  },
  {
    name: 'Stilbaai',
    postalCodes: ['6674'],
    fee: 2250
  },
  {
    name: 'Vredendal',
    postalCodes: ['8160'],
    fee: 2500
  },
  {
    name: 'Mossel Bay',
    postalCodes: ['6500'],
    fee: 3000
  },
  {
    name: 'Little Brak River',
    postalCodes: ['6503'],
    fee: 3000
  },
  {
    name: 'Hartenbos',
    postalCodes: ['6520'],
    fee: 3000
  },
  {
    name: 'Groot Brak Rivier',
    postalCodes: ['6525'],
    fee: 3000
  },
  {
    name: 'Oudtshoorn',
    postalCodes: ['6620'],
    fee: 3250
  },
  {
    name: 'George',
    postalCodes: ['6529'],
    fee: 3500
  },
  {
    name: 'Wilderness',
    postalCodes: ['6560'],
    fee: 3500
  },
  {
    name: 'Sedgefield',
    postalCodes: ['6573'],
    fee: 3750
  },
  {
    name: 'Knysna',
    postalCodes: ['6570'],
    fee: 3750
  },
  {
    name: 'Plettenberg Bay',
    postalCodes: ['6600'],
    fee: 4000
  },
  {
    name: "Nature's Valley",
    postalCodes: ['6602'],
    fee: 4000
  },
  {
    name: 'Storms River',
    postalCodes: ['6308'],
    fee: 4250
  }
];
